import v1 from './v1/index'
import simcard from './simcard/index'

export default {
  v1,
  simcard
}
